import React from "react"
import { NavBar } from "../Navbar"
import { LandingSection } from "./LandingSection"
import { CompromisoSection } from "./CompromisoSection"
import { TecnologiaSection } from "./TecnologiaSection"
import { EmpresasSection } from "./EmpresasSection"

export const Home = () => {
  const colorText = "white"
  const classTitle = "home"
  return (
    <>
      <NavBar colorText={colorText} classTitle={classTitle} />
      <LandingSection classTitle={classTitle} />
      <CompromisoSection />
      {/* <TecnologiaSection classTitle={classTitle} /> */}
      <EmpresasSection classTitle={classTitle} />
    </>
  )
}
